import { Sun, CalendarDays, Calendar, CalendarRange, CheckCircle2, Clock } from 'lucide-react';

const PERIOD_META = {
  today: { cls: 'ppc-today', icon: Sun },
  week:  { cls: 'ppc-week',  icon: CalendarDays },
  month: { cls: 'ppc-month', icon: Calendar },
  year:  { cls: 'ppc-year',  icon: CalendarRange },
};

const CONF_COLOR = {
  today: 'var(--amber2)',
  week:  'var(--amber2)',
  month: 'var(--purple)',
  year:  'var(--muted)',
};

export default function ProjectionGrid({ periods = [] }) {
  return (
    <div className="proj-grid">
      {periods.map((p, i) => {
        const meta  = PERIOD_META[p.key] ?? PERIOD_META.week;
        const Icon  = meta.icon;
        const isHit = p.verdict === 'hit' || p.verdict === 'beat';

        return (
          <div key={i} className={`ppc ${meta.cls}`}>
            <div className="ppc-head">
              <Icon size={14} />
              <span className="ppc-period">{p.label}</span>
            </div>
            <div className="ppc-date">{p.date}</div>
            <div className="ppc-range">{p.range}</div>
            <div>
              <span className={`badge ${isHit ? 'b-hit' : 'b-pend'}`}>
                {isHit ? <CheckCircle2 size={9} /> : <Clock size={9} />}
                {isHit ? (p.verdict === 'beat' ? 'Beat' : 'Hit') : 'Pending'}
              </span>
            </div>
            {p.actual && <div className="ppc-actual">{p.actual} ✓</div>}
            {p.scenarios?.length > 0 && (
              <div className="sce-rows">
                {p.scenarios.map((s, j) => (
                  <div key={j} className={`sce-row${s.hit ? ' hit' : ''}`}>
                    <span className={`sce-lbl sce-${s.variant}`}>
                      {s.variant === 'bull' ? 'Bull' : s.variant === 'base' ? 'Base' : 'Bear'}
                    </span>
                    <span className="sce-range">{s.range}</span>
                    <span className="sce-prob">{s.prob}%</span>
                  </div>
                ))}
              </div>
            )}
            {p.confidence != null && (
              <div className="ppc-conf">
                <div className="ppc-conf-bar">
                  <div
                    className="ppc-conf-fill"
                    style={{ width: `${p.confidence}%`, background: isHit ? 'var(--green)' : CONF_COLOR[p.key] }}
                  />
                </div>
                <span className="ppc-conf-pct">{p.confidence}% conf.</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
